import { motion } from 'framer-motion';
import React from 'react';
import { FaAngleRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Meta } from '../components';
import Loader from '../components/Loader';
import BreadCrumb from '../ScreenComponents/ShearCompo/BreadCrumb/BreadCrumb';
import './Css/ConfirmedOrder.scss';
import img1 from "../assets/img/image.png";

const ConfirmedOrder = () => {
    const loading = false;
    const headerData = [
        { title: "Date", desc: "Dec 20, 2021 8:15PM", className: "common lightGolden" },
        { title: "Order No.", desc: "#5826 (Track)", className: "common darkPurple" },
        { title: "Total", desc: "৳ 45045.00 (Unpaid)", className: "common darkLime" },
        { title: "Payment Method", desc: "Cash on Delivery (CoD)", className: "common bg-light" },
    ]
    return (
        <motion.div exit={{ opacity: 0 }} id="confirmed_order__page" initial='initial' animate='animate'>
            {loading && <Loader />}
            <Meta title={'Order Confirmed __bubu Shopkpr'} />
            <BreadCrumb title={<span className=" d-flex items-end h-auto">
                <Link className="link" to='/'>Home</Link>
                <div className="d-flex items-center">
                    <FaAngleRight />
                    <span className="notLink">Confirmed Order</span>
                </div>
            </span>} />
            <div className='headerTop'>
                <div className='d-flex justify-between'>
                    <p>Thank you, your order has been received.</p>
                    <Link to="/shop">Continue Shopping</Link>
                </div>
            </div>
            <div className='row headerBottom py-5'>
                {headerData.map((data, index) =>
                    <div className={`col-md-3 px-2 `} key={index}>
                        <div className={`${data.className} `}>
                            <p className="title">{data.title}</p>
                            <p className='desc'>{data.desc}</p>
                        </div>
                    </div>
                )}
            </div>
            <div className='row shipping_details'>
                <div className='col-lg-6 col-xl-5 '>
                    <div className='shipping_details_from px-5 pb-5 lg:px-0 bg-light'>
                        <div className='order_details'>
                            <h2 className='title'>Order Details</h2>
                            <div className='detailsTitle d-flex items-center justify-between'>
                                <span className='common small' />
                                <p>Product</p>
                                <span className='common big' />
                                <p>Qty</p>
                                <span className='common small' />
                                <p>Subtotal</p>
                                <span className='common small' />
                            </div>
                            <div className='productDetails d-flex justify-around'>
                                <Link to="/">Plain White T-shirt - Sk 1645665</Link>
                                <strong>x100</strong>
                                <span>৳ 45000.00</span>
                            </div>
                            <div className='productDetails shipping_details_common d-flex justify-between px-4'>
                                <Link to="/">Subtotal</Link>
                                <span>৳ 45000.00</span>
                            </div>
                            <div className='productDetails shipping_details_common d-flex justify-between px-4'>
                                <Link to="/">Shipping</Link>
                                <span>Flat Rate ৳ 45000.00</span>
                            </div>
                            <div className='total d-flex justify-between px-4'>
                                <p>Total</p>
                                <p>৳ 45045.00</p>
                            </div>
                            <div className='btn_group'>
                                <div className='d-flex justify-between'>
                                    <button className='btn download'>Download Invoice</button>
                                    <button className='btn trackOrder'>Track Order</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-lg-6 col-xl-7 '>
                    <div className='row bg-light shipping_details_right ml-4 p-5 h-100'>
                        <h2 className='smallTile text-center'>Product Breakdown</h2>

                        <div className='col-md-6 img_parent'>
                            <img src={img1} alt="" />
                        </div>
                        <div className='details_info col-lg-6 col-xl-7'>
                            <div className='d-flex flex-column productDetails'>
                                <p className='title'>Plain White T-shirt - SK1645665</p>
                                <p className='d-flex'>Color: White <span className='color d-block'></span></p>
                                <p className='d-flex'>Size: L (Large)</p>
                                <p className='d-flex'>Category: lorem, lorem</p>
                                <p className='d-flex'>Unit Price: ৳450.00</p>
                                <p className='d-flex'>Total Price: ৳45000.00</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </motion.div>
    );
};

export default ConfirmedOrder;